module.exports = __webpack_public_path__ + "img/bg1.b0b27498.jpg";